'use client';

import merciiiLogo from '@/assets/logos/partners/merciii.svg';
import { Trans, t } from '@lingui/macro';
import { Box, Stack, Typography } from '@mui/material';
import { Button } from '@prismo-io/design-system';
import Image from 'next/image';
import Link from 'next/link';
import type { FC } from 'react';

type Props = {
  order: number;
};

export const MerciiiCard: FC<Props> = (props: Props) => {
  const { order } = props;

  return (
    <Stack
      component="article"
      bgcolor="background.paper"
      // bgcolor="background.primary"
      borderRadius="3rem"
      p={2}
      zIndex={10}
      minWidth={{ none: '100%', sm: '45%', lg: '31%' }}
      sx={{
        boxShadow: '2px 2px 7px 0px rgba(0,0,0,0.3)',
        flex: '1 1 0%',
        order: order,
      }}
      direction="column"
      alignItems="center"
      spacing={2}
    >
      <Box component="div" position="relative" width="10.5rem" height="10.5rem">
        <Image
          src={merciiiLogo}
          alt=""
          style={{ objectFit: 'contain', objectPosition: 'center' }}
          fill
        />
      </Box>
      <Typography textAlign="center">
        <Trans>
          En quelques minutes, trouvez la mission d'intérim qui vous correspond
          !
        </Trans>
      </Typography>
      <Box component="div">
        <Link
          href={'https://merciii.fr/prismo/secteurs'}
          passHref
          legacyBehavior
          target="_blank"
        >
          <Button variant="text" color="inherit">
            <Trans>C'est parti !</Trans>
          </Button>
        </Link>
      </Box>
    </Stack>
  );
};
